export const AVAILABILITY_SETTING_USERS = "/api/availability-settings-per-user"
export const AVAILABILITY_SETTING_USER = "/api/availability-settings-per-user/:param"
